import { FabMenuItem, OverlayState } from '../states/overlay'
import {
	UserActionTypes,
	canCreateActivity,
	canCreateDocument,
	canCreateTopic,
	canCreateReleasedTask,
	canCreateReleasedNews,
	canCreateForm,
	canCreateThread,
	canCreateReleasedVisit,
} from '@Techedge/digitalportal-shared'
import { LuxChatbotIcon } from '@lux/wardrobe-lib'

export const OVERLAY_REDUCER_NAMESPACE = 'overlayReducer'

export enum OverlayAction {
	OPEN_PROJECT_CREATION = 'openProjectCreation',
	CLOSE_PROJECT_CREATION = 'closeProjectCreation',
	SET_SHOW_APP_LOADER = 'setShowAppLoader',
	SET_SHOW_ADD_PHOTO_DIALOG = 'setShowAddPhotoDialog',
	SET_IS_APP_LOADED = 'setIsAppLoaded',
	OPEN_RESOURCE_CREATION = 'openResourceCreation',
	CLOSE_RESOURCE_CREATION = 'closeResourceCreation',
	OPEN_DOCUMENT_CREATION = 'openDocumentCreation',
	OPEN_SUBFOLDER_CREATION = 'openSubfolderCreation',
	OPEN_FOLDER_CREATION = 'openFolderCreation',
	OPEN_DISCUSSION_CREATION = 'openDiscussionCreation',
	OPEN_PHOTO_CREATION = 'openPhotoCreation',
	SHOW_TOAST_UPLOAD_PHOTO_ERROR = 'showToastUploadPhotoError',
	OPEN_CHATBOT = 'openChatbot',
	FILTER_MENU_ITEMS = 'filterMenuItems',
}

const menuItems: FabMenuItem[] = [
	{
		label: 'overlay.fab.menu.activity',
		icon: 'document-plus',
		action: OverlayAction.OPEN_PROJECT_CREATION,
		permission: () =>
			canCreateActivity() ||
			canCreateReleasedTask() ||
			canCreateReleasedNews() ||
			canCreateReleasedVisit(),
		routes: [
			{ path: '/', exact: true },
			{ path: '/home', exact: true },
			{ path: '/calendar', exact: true },
			{ path: '/activity', exact: true },
			{ path: '/gallery', exact: true },
			{ path: '/menu/store-list', exact: true },
		],
	},
	{
		label: 'overlay.fab.menu.photo',
		icon: 'camera',
		action: OverlayAction.OPEN_PHOTO_CREATION,
		permission: (ph2Enalbed) => ph2Enalbed,
		routes: [
			{ path: '/', exact: true },
			{ path: '/home', exact: true },
			{ path: '/calendar', exact: true },
			{ path: '/activity', exact: true },
			{ path: '/gallery', exact: true },
			{ path: '/menu/store-list', exact: true },
		],
	},
	{
		label: 'overlay.fab.menu.discussion',
		icon: 'comments',
		action: OverlayAction.OPEN_DISCUSSION_CREATION,
		permission: () => canCreateThread() || canCreateTopic(),
		routes: [{ path: '/menu/forum' }],
	},
	{
		label: 'overlay.fab.menu.document',
		icon: 'file-plus',
		action: OverlayAction.OPEN_DOCUMENT_CREATION,
		permission: () => canCreateDocument() || canCreateForm(),
		routes: [{ path: '/resources' }],
	},
	{
		label: 'overlay.fab.menu.subfolder',
		icon: 'folders-plus',
		action: OverlayAction.OPEN_SUBFOLDER_CREATION,
		permission: () => canCreateDocument() || canCreateForm(),
		routes: [{ path: '/resources' }],
	},
	{
		label: 'overlay.fab.menu.folder',
		icon: 'folder-plus',
		action: OverlayAction.OPEN_FOLDER_CREATION,
		permission: () => canCreateDocument() || canCreateForm(),
		routes: [{ path: '/resources' }],
	},
	{
		label: 'overlay.fab.menu.chatbot',
		iconComponent: LuxChatbotIcon,
		action: OverlayAction.OPEN_CHATBOT,
		permission: () => true,
		routes: [],
	},
]

let defaultstate: OverlayState = {
	showProjectCreation: false,
	menuItems: [],
	showAppLoader: true,
	isAppLoaded: false,
	showResourceCreation: false,
	showAddPhotoDialog: false,
}

export default (state: OverlayState = defaultstate, action: any) => {
	switch (action.type) {
		case OverlayAction.OPEN_PROJECT_CREATION:
			return {
				...state,
				showProjectCreation: true,
			}
		case OverlayAction.CLOSE_PROJECT_CREATION:
			return {
				...state,
				showProjectCreation: false,
			}
		case UserActionTypes.SMARTLY_PERMISSION_UPDATED:
			const currentPath = window.location.pathname
			return {
				...state,
				currentPath,
			}
		case OverlayAction.SET_SHOW_APP_LOADER:
			return {
				...state,
				showAppLoader: action.showAppLoader,
			}
		case OverlayAction.SET_IS_APP_LOADED:
			return {
				...state,
				isAppLoaded: action.isAppLoaded,
			}
		case OverlayAction.OPEN_RESOURCE_CREATION:
			return {
				...state,
				showResourceCreation: true,
			}
		case OverlayAction.CLOSE_RESOURCE_CREATION:
			return {
				...state,
				showResourceCreation: false,
			}
		case OverlayAction.OPEN_DOCUMENT_CREATION:
			return {
				...state,
				showResourceCreation: true,
			}
		case OverlayAction.OPEN_SUBFOLDER_CREATION:
			return {
				...state,
				showResourceCreation: true,
			}
		case OverlayAction.OPEN_FOLDER_CREATION:
			return {
				...state,
				showResourceCreation: true,
			}
		case OverlayAction.SET_SHOW_ADD_PHOTO_DIALOG:
			return {
				...state,
				showAddPhotoDialog: action.payload,
			}
		case OverlayAction.FILTER_MENU_ITEMS:
			return {
				...state,
				menuItems: menuItems.filter((item) => {
					if (!item.routes) return true
					return item.routes.some((route) => {
						if (route.exact) {
							return route.path === window.location.pathname
						}
						return window.location.pathname.startsWith(route.path)
					})
				}),
			}
		default:
			return state
	}
}
